module.exports = __webpack_public_path__ + "static/media/cardSecond.5809ffbc.svg";